import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { DialogShow } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
//PAGE
import P107List from "./P107List";

//CSS
import "../../../components/DataTable/DataTable.css";
import P107Search from "./P107Search";

//SERVICE
import { P107GetDataList } from "../../../service/100/P107Service";
import { formatDateAPI } from "../../../utilities/DateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P107() {
    const history = useHistory();
    const toast = useRef(null);
    const [dataTable, setDataTable] = useState([]);
    const [dataShow, setDataShow] = useState({ userId: "", userFullName: "" });
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [showDialog, setShowDialog] = useState(false);
    const [textShow] = useState("");

    // SEARCH
    const [searchData] = useState({
        contractNo: "",
        orderDateBegin: "",
        orderDateEnd: "",
        orderStatus: "",
        searchWord: "",
        supervisor: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state && history.location.state.dataSrh ? history.location.state.dataSrh : ""),
    });

    useEffect(() => {
        if (dataUserSession()) {
            setDataShow({
                userId: dataUserSession() ? dataUserSession().userId : "",
                userFullName: dataUserSession().userFullName,
            });
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onP107GetDataList();
    }, [searchData]);

    const onP107GetDataList = async () => {
        setLoading(true);
        let dataSrh = {
            ...searchData,
            orderDateBegin: searchData.orderDateBegin !== "" ? formatDateAPI(searchData.orderDateBegin, false) : "",
            orderDateEnd: searchData.orderDateEnd !== "" ? formatDateAPI(searchData.orderDateEnd, false) : "",
        };
        await P107GetDataList(dataSrh).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">งานสั่งการเฉพาะอย่างคงค้าง</h2> */}
                        {/* <hr/> */}
                        {/* <P107Search dataShow={dataShow} /> */}
                        <P107List dataTable={dataTable} searchData={searchData} />
                    </div>
                </div>

                <DialogShow visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
            </div>
        </>
    );
}
